import React, { createContext, useContext, useEffect, useState } from "react";
import { api, imageUrl } from "../lib/api";

const FALLBACK = {
  logo_path: null,
  hero_path: null,
  logo_url: "https://customer-assets.emergentagent.com/job_infinity-manage/artifacts/mtksx1dv_Infinity-DMS_LOGO-3.jpg",
  hero_url: "/hero-rainbow.jpg",
  pillar_connectivity_url: null,
  pillar_cloud_url: null,
  pillar_smart_url: null,
  build_package_url: null,
};

const SLOTS = [
  "logo",
  "hero",
  "pillar_connectivity",
  "pillar_cloud",
  "pillar_smart",
  "build_package",
];

const BrandContext = createContext(FALLBACK);

export const BrandProvider = ({ children }) => {
  const [brand, setBrand] = useState(FALLBACK);

  useEffect(() => {
    let cancelled = false;
    api
      .get("/brand")
      .then((r) => {
        if (cancelled) return;
        const b = r.data || {};
        const next = { ...FALLBACK };
        SLOTS.forEach((slot) => {
          const path = b[`${slot}_path`];
          next[`${slot}_path`] = path || null;
          // Don't overwrite logo/hero fallback URL when no path
          const hasFallback = slot === "logo" || slot === "hero";
          next[`${slot}_url`] = path
            ? imageUrl(path)
            : hasFallback
              ? FALLBACK[`${slot}_url`]
              : null;
        });
        setBrand(next);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return <BrandContext.Provider value={brand}>{children}</BrandContext.Provider>;
};

export const useBrand = () => useContext(BrandContext);
